uniform float uTime;
uniform float uSize;
uniform float uSpeed;

attribute float aScale;
attribute vec3 aRandomness;

varying vec3 vColor;

void main()
{
    // Position
    vec4 modelPosition = modelMatrix * vec4(position, 1.0);

    // Spin
    float angle = atan(modelPosition.x, modelPosition.z);
    float radius = length(modelPosition.xz);
    float angleOffset = (1.0 / radius) * uTime * uSpeed;
    angle += angleOffset;

    modelPosition.x = sin(angle) * radius;
    modelPosition.z = cos(angle) * radius;

    // Randomness
    modelPosition.xyz += aRandomness;

    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    gl_Position = projectedPosition;


    // Size
    gl_PointSize = uSize * aScale;
    // Size Attenuation
    gl_PointSize *= (1.0 / - viewPosition.z);

    vColor = color;
}
